import cx from "classnames";
import React from "react";
import { useSelector } from "react-redux";

// import { BasicIconButton } from "@gaming/xds-react-js";
import { BasicButton, Icon, IconSize } from "@gaming/xds-react-js";
import { AppIconHelp } from "@gaming/xds-react-js-icons";

import {
  useProgramColorPicker,
  useProgramFillColorPicker,
} from "../../helpers/useProgramColorPicker";
import { useString } from "../../localization/localizationHelpers";
import { getOnboardingSignedIn } from "../../redux/selectors/authSelectors";
import * as styles from "./HelpLink.module.css";

type HelpLinkProps = Readonly<{
  email: string;
}>;

const HelpLink = ({ email }: HelpLinkProps) => {
  const helpLink = useString("helpLink");
  const isSignedIn = useSelector(getOnboardingSignedIn);
  const colorStyle = useProgramColorPicker();
  const fillColor = useProgramFillColorPicker();

  if (!isSignedIn) {
    return null;
  }

  const handleClick = () => {
    window.location.href = `mailto:${email}`;
  };

  return (
    <div className={styles.linkContainer}>
      <BasicButton
        as={"button"}
        className={cx(styles.link, colorStyle)}
        onClick={handleClick}
        tabIndex={0}
        role="link"
      >
        <Icon
          aria-hidden={true}
          icon={AppIconHelp}
          className={cx(styles.customIcon, fillColor)}
          iconSize={IconSize.Custom}
        />
        <p className={cx(styles.iconText, colorStyle)}>{helpLink}</p>
      </BasicButton>
    </div>
  );
};

export const IdXboxHelpLink = () => <HelpLink email="id@xbox.com" />;

export const IdAzureHelpLink = () => <HelpLink email="idazure@microsoft.com" />;

export const PitchHelpLink = () => <HelpLink email="id@xbox.com" />;
